import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Box,
  Spinner,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from "@chakra-ui/react";
import { PaginateNavigate } from "components/paginateComponent/PaginateComponent";
import { useState } from "react";
import React from "react";
import { formaterDocument } from "utils/formaterDocumente";
import { UseDashboard } from "hooks/DashboardHook";
import { useQuery } from "react-query";

interface ModalVersionsProps {
  isOpen: boolean;
  onClose: () => void;
  modulo: string;
  version: string;
  dias: number;
}

export function ModalVersion(props: ModalVersionsProps) {
  const brandColor = useColorModeValue("brand.500", "white");
  const [paginate, setPaginate] = useState<number>(1);
  const boxBg = useColorModeValue("secondaryGray.300", "navy.900");
  const subTable = useColorModeValue("secondaryGray.300", "navy.700");
  const [exibirDetalhes, setExibirDetalhes] = useState<any>({});

  const { findTerminalVersions } = UseDashboard();

	console.log(paginate)
  const { data, isLoading, error } = useQuery(
    ["findTerminalVersions", props.modulo, props.version, props.dias, paginate],
    () =>
      findTerminalVersions({
        days: props.dias,
        module: props.modulo,
        page: paginate,
        version: props.version,
      })
  );

  const toggleDetalhes = (chave: any) => {
    setExibirDetalhes((prevState: any) => ({
      ...prevState,
      [chave]: !prevState[chave],
    }));
  };

  return (
    <Modal
      motionPreset="slideInBottom"
      size="6xl"
      isOpen={props.isOpen}
      onClose={props.onClose}
    >
      <ModalOverlay />
      <ModalContent bg={boxBg}>
        <ModalHeader>
          {props.modulo} / {props.version}  | {data?.total}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {isLoading ? (
            <Box display="flex" alignItems="center" justifyContent="center">
              <Spinner
                speed="0.65s"
                width="100px"
                height="100px"
                thickness="4px"
              />
            </Box>
          ) : error ? (
            <Box color="red.500" textAlign="center">
              {String(error || "")}
            </Box>
          ) : (
            <>
              <TableContainer>
                <Table>
                  <Thead>
                    <Tr>
                      <Th>Empresa</Th>
                      <Th>CNPJ</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {data?.data.map((empresa: any, idx: number) => {
                      return (
                        <React.Fragment key={empresa.NOME + idx}>
                          <Tr
                            color={brandColor}
                            cursor={"pointer"}
                            _hover={{
                              bg: "var(--chakra-filled-background-hover)",
                            }}
                            onClick={() => toggleDetalhes(idx)}
                            transition={"0.3s"}
                          >
                            <Td>{empresa.NOME}</Td>
                            <Td>{formaterDocument(empresa.DOCUMENTO)}</Td>
                          </Tr>
                          {exibirDetalhes[idx] && (
                            <Tr>
                              <Td colSpan={2}>
                                <Table bg={subTable}>
                                  <Thead>
                                    <Tr>
                                      <Th>ID</Th>
                                      <Th>NOME</Th>
                                      <Th>DATA</Th>
                                    </Tr>
                                  </Thead>
                                  <Tbody>
                                    {empresa.TERMINAIS.map(
                                      (item: any, index: number) => (
                                        <Tr key={item.ID || index}>
                                          <Td>{item.ID}</Td>
                                          <Td>{item.NOME_TERMINAL}</Td>
                                          <Td>{item.DATA}</Td>
                                        </Tr>
                                      )
                                    )}
                                  </Tbody>
                                </Table>
                              </Td>
                            </Tr>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </Tbody>
                </Table>
              </TableContainer>
              <PaginateNavigate
                current_page={data?.current_page}
                pages_preview={data?.links}
                pageSelect={setPaginate}
                lastPage={data?.last_page}
              />
            </>
          )}
        </ModalBody>

        <ModalFooter>
          <Button colorScheme="red" onClick={props.onClose}>
            Fechar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
